import React from 'react'

import {createSvgIcon} from './utils'

export default createSvgIcon(
  <path
    d="M12 19C11.0337 19 10.1263 18.8173 9.27778 18.452C8.42929 18.0985 7.68098 17.6035 7.03283 16.9672C6.39646 16.319 5.89562 15.5707 5.5303 14.7222C5.17677 13.8737 5 12.9663 5 12C5 11.0219 5.17677 10.1145 5.5303 9.27778C5.89562 8.42929 6.39646 7.68687 7.03283 7.0505C7.68098 6.40236 8.42929 5.90151 9.27778 5.54798C10.1263 5.18266 11.0337 5 12 5C12.9781 5 13.8855 5.18266 14.7222 5.54798C15.5707 5.90151 16.3131 6.40236 16.9495 7.0505C17.5976 7.68687 18.0985 8.42929 18.452 9.27778C18.8173 10.1145 19 11.0219 19 12C19 12.9663 18.8173 13.8737 18.452 14.7222C18.0985 15.5707 17.5976 16.319 16.9495 16.9672C16.3131 17.6035 15.5707 18.0985 14.7222 18.452C13.8855 18.8173 12.9781 19 12 19Z"
    fill="inherit"
  />,
  'DotLIcon',
  {viewBox: '0 0 24 24'},
)
